var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group w-full px-1"},[_c('label',{staticClass:"form-label",attrs:{"for":"body"},domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('editor',{attrs:{"name":_vm.name,"value":_vm.content,"init":_vm.settings,"tag-name":"textarea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }